import { queryClient } from '../../../../api/queryClient';

// Clave única para la caché de sucursales
const BRANCHES_CACHE_KEY = 'all-branches-data';

/**
 * Invalida la caché de sucursales para forzar una nueva carga de datos
 * Se debe llamar después de cualquier modificación en las sucursales
 */
function invalidateBranchesCache(): void {
  queryClient.invalidateQueries([BRANCHES_CACHE_KEY]);
}

/**
 * Verifica si existe caché válida para las sucursales
 */
function hasBranchesCache(): boolean {
  return queryClient.getQueryData([BRANCHES_CACHE_KEY]) !== undefined;
}

export default {
  BRANCHES_CACHE_KEY,
  invalidateBranchesCache,
  hasBranchesCache
};
